import { createContext, Dispatch, FC, PropsWithChildren, SetStateAction, useState } from 'react';
import { TransactionsDateFilterState } from './TransactionsDateFilterState';
import { FilterFn } from '../../../components/table/interfaces/FilterFn';
import { Transaction } from '../../types/Transaction';
import { TransactionPropertiesGroup } from './TransactionPropertiesGroup';
import { useTransactionsDateSetFilterFunction } from './useTransactionsDateSetFilterFunction';
import { isTransactionsDateFilterChanged } from './isTransactionsDateFilterChanged';

export const initialTransactionsDateFilterState: TransactionsDateFilterState = {
  started: null,
  startedDateRange: null,
  approved: null,
  approvedBy: null,
  approvedDateRange: null,
};

interface TransactionsDateFilterContextValue {
  group: TransactionPropertiesGroup;
  popupOpened: boolean;
  setPopupOpened: Dispatch<SetStateAction<boolean>>;
  state: TransactionsDateFilterState;
  setState: Dispatch<SetStateAction<TransactionsDateFilterState>>;
  changed: boolean;
}

export const TransactionsDateFilterContext = createContext({} as TransactionsDateFilterContextValue);

function useTransactionsDateFilterContextValue(
  group: TransactionPropertiesGroup,
  filterFn: FilterFn<Transaction, TransactionsDateFilterState>,
): TransactionsDateFilterContextValue {
  const [popupOpened, setPopupOpened] = useState(false);
  const [state, setState] = useState<TransactionsDateFilterState>(initialTransactionsDateFilterState);
  const changed = isTransactionsDateFilterChanged(state);

  useTransactionsDateSetFilterFunction(changed, state, filterFn);

  return { group, popupOpened, setPopupOpened, state, setState, changed };
}

export const TransactionsDateFilterContextProvider: FC<
  PropsWithChildren<{
    group: TransactionPropertiesGroup;
    filterFn: FilterFn<Transaction, TransactionsDateFilterState>;
  }>
> = ({ group, filterFn, children }) => (
  <TransactionsDateFilterContext.Provider value={useTransactionsDateFilterContextValue(group, filterFn)}>
    {children}
  </TransactionsDateFilterContext.Provider>
);
